import React, { Component } from 'react';

import henrik from  './assets/henrik.jpg';
import gitte from  './assets/gitte.jpg';
import styles from  './styles.js';

class GitteHenrik extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
			//backgroundImage: `url(${bgImage})`,
			//backgroundSize: 'cover'

		});

		return (
			<div style={elmStyl} className='gitteHenrik'>
				<div style={styles.flexEmpty}>

					<div style={styles.portrait} >
						<img style={styles.portrait_img} src={henrik} alt='Henrik' />
						<p style={styles.portrait_p}>Henrik</p>
					</div>
					<div style={styles.portrait}>
						<img style={styles.portrait_img} src={gitte} alt='Gitte'/>
						<p style={styles.portrait_p}>Gitte</p>
					</div>	
					<div
						data-0-start="-webkit-transform-origin: 50% 50% 0"
						data-end="-webkit-transform-origin: 0 0 0"
						>
					
					</div>
				</div>
			</div>

		)
	}
}

export default GitteHenrik;



// WEBPACK FOOTER //
// ./src/components/GitteHenrik.js